import {
    GLOBAL_INFO,
    RESET_GLOBAL_INFO
} from './GlobalActionTypes';

export const globalInfo = (message) => ({
    type: GLOBAL_INFO,
    message,
})

export const resetGlobalInfo = () => ({
    type: RESET_GLOBAL_INFO,
})